import React, { useCallback, useState, Fragment as F } from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import isEmpty from 'lodash/isEmpty'

import get from 'lodash/get'

import * as Highcharts from 'highcharts'
import HC_more from 'highcharts/highcharts-more'
import HighchartsReact from 'highcharts-react-official'

import { INTENTS_LABEL_STRINGS, INTENTS_EMOJI } from 'reducers/quoteReducers'
import './LeadStory.scss'
import { getEntity } from 'selectors/entitySelectors'

const GRAPH_COLORS = ['#deb053', '#000000']

Highcharts.setOptions({
  chart: {
    style: {
      //fontFamily: 'Montserrat',
    },
    backgroundColor: 'transparent',
  },
})

HC_more(Highcharts)

const FrequencyChart = ({ title, frequencies = {}, clicks }) => {
  if (isEmpty(Object.values(frequencies))) return null

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        chart: {
          type: 'column',
        },
        legend: { enabled: false },
        title: {
          text: title,
        },
        xAxis: {
          categories: Object.keys(frequencies),
          crosshair: true,
        },
        yAxis: {
          allowDecimals: false,
          labels: { enabled: false },
          title: { enabled: false },
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y}</b></td></tr>' +
            (clicks
              ? `<tr><td style="padding:0">Times clicked: </td><td style="padding:0"><b>{point.clicks}</b></td></tr>`
              : ''),
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            pointPadding: 0,
            borderWidth: 3,
            groupPadding: 0,
            shadow: false,
          },
          series: {
            stacking: 'normal',
          },
        },
        series: [
          {
            name: title,
            data: Object.values(frequencies).map((f, i) => ({
              y: f,
              clicks: clicks ? clicks[Object.keys(frequencies)[i]] : '0',
              color: GRAPH_COLORS[0],
            })),
          },
        ],
      }}
    />
  )
}

const WithToolTip = ({ hint, children, frequencies, clicks, showTooltip }) => {
  const [style, setStyle] = useState({})
  const [hovered, setHovered] = useState(false)

  const boundingRef = useCallback(
    node => {
      if (!node) {
        return null
      }
      const right = node.getBoundingClientRect().right
      const pageWidth =
        window.innerWidth || document.documentElement.clientWidth
      const overflowsRight = right > pageWidth
      setStyle({
        marginLeft:
          overflowsRight && hovered ? pageWidth - (right + 15) : undefined,
      })
    },
    [hovered],
  )

  return showTooltip ? (
    <span
      className="tooltip-wrapper"
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span
        ref={boundingRef}
        style={Object.keys(style).length === 0 ? undefined : style}
        className="tooltip"
      >
        {frequencies ? (
          <FrequencyChart
            title={hint}
            frequencies={frequencies}
            clicks={clicks}
          />
        ) : (
            hint
          )}
      </span>
      <strong>{children}</strong>
    </span>
  ) : (
      <strong>{children}</strong>
    )
}

const ReconstructedSentence = ({ fragments = [], showTooltips = true }) => {
  if (fragments.length === 0) {
    return null
  } else {
    return fragments.map((fragment, i) => {
      if (
        !fragment ||
        typeof fragment === 'string' ||
        typeof fragment === 'number'
      ) {
        return <F key={i}>{get(fragment, 'copy', fragment)} </F>
      } else {
        switch (fragment.type) {
          case 'line-break':
            return (
              <br style={{ content: "&nbsp;", margin: "1ex 0", display: "block" }} />
            )
          case 'reaction':
            return (
              <strong key={i}>
                {INTENTS_LABEL_STRINGS[fragment.value]}{' '}
                {INTENTS_EMOJI[fragment.value]}{' '}
              </strong>
            )
          case 'tooltip':
            return (
              <F key={i}>
                <WithToolTip {...fragment} showTooltips={showTooltips}>
                  {typeof fragment === 'string' ||
                    typeof fragment === 'number' ? (
                      <strong>{fragment.copy}</strong>
                    ) : (
                      <ReconstructedSentence fragments={[fragment.copy]} />
                    )}{' '}
                </WithToolTip>
              </F>
            )
          default:
            return null
        }
      }
    })
  }
}

const LeadStory = props => {
  let { title, stories = [], className } = props

  return (
    <span className={c('lead-story', className)}>
      {title && <h3>{title}</h3>}
      {stories.map((fragments, i) => (
        <ReconstructedSentence {...props} key={i} fragments={fragments} />
      ))}
    </span>
  )
}

function mapStateToProps(state, op) {
  let { stories } = getEntity(state, op.id)

  return {
    ...op,
    stories,
  }
}

export const ConnectedLeadStory = connect(mapStateToProps)(LeadStory)

export default LeadStory
